import { Form, Formik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, FormGroup, Input, Modal, ModalBody, Row } from "reactstrap";
import { setEndStaffSessionModalOpen } from "../../redux/actions/staffSession/staffSessionAction";
import EndStaffSessionForm from "../../components/staffSession/end/endStaffSessionForm";

export const CloseStaffSession = () => {
  const dispatch = useDispatch();
  const { endSessionModalOpen } = useSelector((state) => state.staffSession);

  const toggle = () => {
    dispatch(setEndStaffSessionModalOpen(!endSessionModalOpen));
  };

  return (
    <section>
      <Modal
        isOpen={endSessionModalOpen}
        toggle={toggle}
        centered={true}
        size="md"
        className="wod-popup large-pop adding-popup add-gym-popup"
      >
        <ModalBody>
          <div className="modal-body-content">
            <EndStaffSessionForm/>
          </div>
        </ModalBody>
      </Modal>
    </section>
  );
};
